<div class="w-100 text-center d-flex align-self-center">
  <div
    class="header-container d-flex align-items-center"
    [ngClass]="{ 'mobile-view': storageService.detectMob() }"
  >
    <div
      #schoolDropdownRef
      class="school-section d-flex align-items-center"
      [ngClass]="{
        'p-0 rounded-0 h-100': storageService.detectMob(),
        'school-section-header': !storageService.detectMob() && user?.role_id !== userRoles.TEACHER_ONLY
      }"
      (click)="showDropDown()"
    >
      <div
        class="logo-img-content d-flex align-items-center justify-content-center"
      >
        <img
          [src]="selectedSchool?.school_logo?.image?.url"
          alt="logo-img"
          class="school-logo-img"
          *ngIf="selectedSchool?.school_logo_id"
          [ngStyle]="{
            'margin-right': !storageService.detectMob() ? '10px' : '6px',
            'margin-left': !storageService.detectMob() ? '0' : '10px'
          }"
        />
      </div>
      <div
        class="label-content d-flex align-items-center justify-content-center"
        [ngClass]="{
          'mr-3 ': !storageService.detectMob()
        }"
        *ngIf="user && user.role_id !== userRoles.TEACHER_ONLY"
      >
        <label
          class="quicksand-bold-label app-name-label mb-0 {{
            user?.profileData?.isViewMultipleSchools === true || user?.role_id === 19 ? 'cursor-pointer' : ''
          }}"
          >{{ selectedSchool?.name }}<br /><label
            class="quicksand-bold-label school-code mb-0"
            *ngIf="selectedSchool?.code"
          >
            ( {{ selectedSchool?.code }} )</label
          ></label
        >
      </div>
      <div
        *ngIf="selectedSchool?.id"
        class="d-flex align-items-center justify-content-center"
      >
        <nb-icon
          class="show-dropdown"
          *ngIf="(user?.profileData?.isViewMultipleSchools === true || user?.role_id === 19) && !isDropdownOpen"
          icon="arrow-ios-downward-outline"
        ></nb-icon>

        <nb-icon
          class="show-dropdown"
          *ngIf="(user?.profileData?.isViewMultipleSchools === true || user?.role_id === 19) && isDropdownOpen"
          icon="arrow-ios-upward-outline"
        ></nb-icon>
      </div>
    </div>

    <!-- To display academic year  -->

    <div
      class="d-flex academic-year-div align-items-center academic-year-section academic-year-wrapper"
      *ngIf="selectedSchoolCalendar && user && user.role_id !== userRoles.TEACHER_ONLY"
      [ngClass]="{
        'p-0 rounded-0 ': storageService.detectMob()
      }"
      (click)="toggleAcademicYearDropdown($event)"
    >
      <div class="label-content">
        <label
          class="quicksand-bold-label year-name-label cursor-pointer hover-effect"
        >
          {{ selectedSchoolCalendar?.calendar_title || 'Academic Year' }}
          <div *ngIf="selectedSchoolCalendar?.start">
            {{ selectedSchoolCalendar?.start | date : 'yyyy' }} -
            {{ selectedSchoolCalendar?.end | date : 'yyyy' }}
          </div>
        </label>
      </div>
      <div
        style="padding: 10px 5px 5px 10px"
        *ngIf="currentSchoolCalendars?.length > 1"
      >
        <nb-icon
          class="show-dropdown hover-effect"
          [icon]="isAcademicYearDropdownOpen ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'"
        ></nb-icon>
      </div>
      <div
        *ngIf="this.user?.profileData?.newAcademicYearAdded"
        class="pill-container"
      >
        <span class="pill-label quicksand-bold-label">New</span>
        <span class="blink-hand">
          <img src="/assets/icons/hand-icon.svg" alt="Hand Icon" />
        </span>
      </div>
    </div>
  </div>
</div>

<div
  #dropdownRef
  [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''"
>
  <nb-card
    class="cursor-pointer dropdown dropdown-card-content"
    [ngStyle]="{ 'margin-top': !storageService.detectMob() ? '1rem' : '0' }"
    *ngIf="isDropdownOpen"
  >
    <nb-card-body class="p-0">
      <br />

      <div class="search-list-content">
        <div class="form-group has-search mr-3 ml-3">
          <img
            src="/assets/icons/search.svg"
            alt="search-icon"
            class="mt-1 form-control-feedback"
            height="17"
            width="17"
          />
          <input
            type="text"
            class="form-control quicksand-bold-label"
            style="height: 43px"
            placeholder="Search"
            [(ngModel)]="searchText"
            #searchBox
          />
        </div>

        <div
          *ngFor="let school of schools | search : searchText"
          (click)="changeCurrentSchool(school, true)"
          class="classroom-name-list quicksand-bold-label d-flex justify-content-between"
          [ngClass]="school?.name === school.name ? 'active-classroom' : ''"
        >
          <div>
            {{ school.name }}
          </div>

          <div *ngIf="selectedSchool?.id === school?.id">
            <img
              src="/assets/icons/true.svg"
              alt="selected-classroom"
              class="img-dark svg-dark-icon"
            />
          </div>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</div>

<!-- school academic year drop-down -->
<div
  #dropdownRef
  [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''"
>
  <nb-card
    class="cursor-pointer dropdown dropdown-card-content"
    [ngStyle]="{ 'margin-top': !storageService.detectMob() ? '1rem' : '0' }"
    *ngIf="isAcademicYearDropdownOpen"
  >
    <nb-card-body class="p-0">
      <br />

      <div class="search-list-content">
        <div
          *ngFor="let calendar of currentSchoolCalendars"
          (click)="changeCurrentSchoolCalendar(calendar)"
          class="classroom-name-list quicksand-bold-label d-flex justify-content-between"
          [ngClass]="calendar?.name === calendar.name ? 'active-classroom' : ''"
        >
          <div>
            {{ calendar?.calendar_title ? calendar?.calendar_title : 'Academic Year' }}
            {{ calendar?.start | date : 'yyyy' }} -
            {{ calendar?.end | date : 'yyyy' }}
          </div>

          <div *ngIf="selectedSchoolCalendar?.id === calendar?.id">
            <img
              src="/assets/icons/true.svg"
              alt="selected-classroom"
              class="img-dark svg-dark-icon"
            />
          </div>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</div>
